import Swal from "sweetalert2";

export const showSaveConfirmation = (message = "Record saved successfully!") => {
  Swal.fire({
    title: "Saved!",
    text: message,
    icon: "success",
    confirmButtonText: "OK",
  });
};

export const showUpdateConfirmation = (message = "Record updated successfully!") => {
  Swal.fire({
    title: "Updated!",
    text: message,
    icon: "success",
    confirmButtonText: "OK",
  });
};

export const showDeleteConfirmation = (itemName, onConfirm) => {
  Swal.fire({
    title: "Are you sure?",
    html: `You are about to delete <strong>${itemName}</strong>`,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Confirm",
    cancelButtonText: "Cancel",
    reverseButtons: false,
    dangerMode: true,
  }).then((result) => {
    if (result.isConfirmed) onConfirm();
  });
};

export const showCancelConfirmation = (onConfirm, message = "Any unsaved changes will be lost.") => {
  Swal.fire({
    title: "Are you sure?",
    text: message,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, Cancel",
    cancelButtonText: "No",
    reverseButtons: false,
  }).then((result) => {
    if (result.isConfirmed) onConfirm();
  });
};

